// import { useEffect, useState } from 'react';
// import { Save, X } from 'lucide-react';
// import { Apirequests } from '../../utils/ApiRequests';
// import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
// import BtnSpinner from '../../components/BtnSpinner';

// function AddOrEditCourse({ close, setRefresh, course }) {

//     // console.log(course, 'course')

//     const token = localStorage.getItem("token");

//     const [data, setData] = useState({
//         course_id: "",
//         course_title: "",
//         course_description: "",
//         course_price: "",
//         course_discount_percentage: "",
//         course_image: "",
//         course_rating: "",
//         course_status: "",
//         course_precedance: "",
//         notes: { validity: "", currency: "" }
//     });

//     const [isEdit, setIsEdit] = useState(false);
//     const [previewImage, setPreviewImage] = useState("");
//     const [loading, setLoading] = useState({ state: false, name: "" });

//     // For demo purposes - simulating edit mode with sample data


//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setData(prev => ({
//             ...prev,
//             [name]: value
//         }));

//         // Update preview image when image URL changes
//         if (name === 'course_image') {
//             setPreviewImage(value);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (course) {
//             await handleEditCourse(course?.course_id)
//         } else {
//             await handleAddCourse();
//         }
//     };

//     const handleAddCourse = async () => {
//         setLoading({ state: true, name: "addcourse" });
//         try {
//             const res = await Apirequests("courses/create-course", "POST", data, {
//                 Authorization: `Bearer ${token}`,
//             });
//             if (res?.success) {
//                 SuccessTost(res?.message);
//                 close();
//                 setRefresh((prev) => !prev)
//             } else {
//                 ErrorTost(res?.message)
//             }
//         } catch (error) {
//             console.log(error, 'create course error');
//             ErrorTost("Something went wrong, please try again later.")
//         }
//         setLoading({ state: false, name: "" })
//     }

//     const handleEditCourse = async (id) => {
//         setLoading({ state: true, name: "editcourse" });
//         try {
//             const res = await Apirequests(`courses/edit-course/${id}`, 'PUT', data, {
//                 Authorization: `Bearer ${token}`
//             });
//             if (res?.success) {
//                 SuccessTost(res?.message);
//                 close();
//                 setRefresh((prev) => !prev)
//             }
//         } catch (error) {
//             console.log(error, 'create course error');
//             ErrorTost("Something went wrong, please try again later.")
//         }
//         setLoading({ state: false, name: "" })
//     }

//     const handleReset = () => {
//         setData({
//             course_id: "",
//             course_title: "",
//             course_description: "",
//             course_price: "",
//             course_discount_percentage: "",
//             course_image: "",
//             course_rating: "",
//             course_status: "",
//             course_precedance: "",
//             total_lesson: "",
//             total_chapters: ""
//         });
//         setPreviewImage("");
//         setIsEdit(false);
//     };

//     useEffect(() => {

//         if (course) {
//             setData({
//                 course_id: course?.course_id,
//                 course_title: course?.course_title,
//                 course_description: course?.course_description,
//                 course_price: course?.course_price,
//                 course_discount_percentage: course?.course_discount_percentage,
//                 course_image: course?.course_image,
//                 course_rating: course?.course_rating,
//                 course_status: course?.course_status,
//                 course_precedance: course?.course_precedance,
//                 notes: { ...data?.notes, validity: course?.notes?.validity, currency: course?.notes?.currency }
//             });
//             setPreviewImage(course?.course_image)
//             setIsEdit(true)
//         }

//         return () => {
//             setData({
//                 course_id: "",
//                 course_title: "",
//                 course_description: "",
//                 course_price: "",
//                 course_discount_percentage: "",
//                 course_image: "",
//                 course_rating: "",
//                 course_status: "",
//                 course_precedance: "",
//                 notes: {
//                     validity: "",
//                     currency: ""
//                 }
//             })
//             setIsEdit(false);
//             setPreviewImage(null)
//         }
//     }, [course])

//     return (
//         <div className="py-2 px-2 sm:px-2 lg:px-2">
//             <div>
//                 {/* Header */}
//                 <div className="flex justify-between items-center mb-2">
//                     <h1 className="text-3xl font-bold text-gray-900">
//                         {isEdit ? 'Edit Course' : 'Add New Course'}
//                     </h1>
//                     <div className="flex gap-4">
//                         {/* <button
//               onClick={loadEditData}
//               className="px-4 py-2 text-sm font-medium text-blue-600 hover:text-blue-700"
//             >
//               Demo: Load Edit Data
//             </button> */}
//                         {!isEdit && <button
//                             onClick={handleReset}
//                             className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-700"
//                         >
//                             Reset Form
//                         </button>}
//                     </div>
//                 </div>

//                 {/* Form */}
//                 <form onSubmit={handleSubmit} className="bg-white rounded-2xl">
//                     {/* Image Preview */}
//                     <div className="mb-8">
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             Course Image Preview
//                         </label>
//                         <div className="relative h-72 w-full bg-gray-100 rounded-lg overflow-hidden">
//                             {previewImage ? (
//                                 <img
//                                     src={previewImage}
//                                     alt="Course preview"
//                                     className="w-full h-full object-cover"
//                                 />
//                             ) : (
//                                 <div className="flex items-center justify-center h-full text-gray-400">
//                                     No image preview available
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Basic Information */}
//                     <div>
//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Course Title *
//                             </label>
//                             <input
//                                 type="text"
//                                 name="course_title"
//                                 value={data.course_title}
//                                 onChange={handleInputChange}
//                                 required
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter course title"
//                             />
//                         </div>

//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Image URL *
//                             </label>
//                             <input
//                                 type="url"
//                                 name="course_image"
//                                 value={data.course_image}
//                                 onChange={handleInputChange}
//                                 required
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter image URL"
//                             />
//                         </div>

//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Course ID
//                             </label>
//                             <input
//                                 type="text"
//                                 name="course_id"
//                                 value={data.course_id}
//                                 onChange={handleInputChange}
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter course ID"
//                             />
//                         </div>


//                     </div>

//                     {/* Course Details */}
//                     <div>
//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Price *
//                             </label>
//                             <input
//                                 type="tel"
//                                 name="course_price"
//                                 value={data.course_price}
//                                 onChange={handleInputChange}
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter price"
//                             />
//                         </div>
//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Currency
//                             </label>
//                             <select
//                                 value={data?.notes?.currency}
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 onChange={(e) => setData({ ...data, notes: { ...data?.notes, currency: e.target.value } })}>
//                                 <option value={""}>Select Currency</option>
//                                 <option value={"INR"}>Indian Rupee (INR)</option>
//                                 <option value={"USD"}>United States Dollar (USD)</option>
//                             </select>
//                         </div>

//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Discount Percentage
//                             </label>
//                             <input
//                                 type="number"
//                                 name="course_discount_percentage"
//                                 value={data?.course_discount_percentage}
//                                 onChange={handleInputChange}
//                                 min="0"
//                                 max="100"
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter discount"
//                             />
//                         </div>

//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Rating
//                             </label>
//                             <input
//                                 type="tel"
//                                 name="course_rating"
//                                 value={data.course_rating}
//                                 onChange={handleInputChange}
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter rating"
//                             />
//                         </div>

//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Validity(days) *
//                             </label>
//                             <input
//                                 type="tel"
//                                 name="total_lesson"
//                                 value={data?.notes?.validity}
//                                 onChange={(e) => setData({ ...data, notes: { ...data?.notes, validity: e.target.value } })}
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter course validity"
//                             />
//                         </div>

//                         {/* <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Total Chapters *
//                             </label>
//                             <input
//                                 type="tel"
//                                 name="total_chapters"
//                                 value={data.total_chapters}
//                                 onChange={handleInputChange}
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter total chapters"
//                             />
//                         </div> */}

//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Precedence Level *
//                             </label>
//                             <input
//                                 type="tel"
//                                 name="course_precedance"
//                                 value={data.course_precedance}
//                                 onChange={handleInputChange}
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                 placeholder="Enter Priority Number"
//                             />
//                         </div>

//                         <div className='mb-2'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 Status *
//                             </label>
//                             <select
//                                 name="course_status"
//                                 value={data.course_status}
//                                 onChange={handleInputChange}
//                                 required
//                                 className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                             >
//                                 <option value="Active">Active</option>
//                                 <option value="Disabled">Disabled</option>
//                             </select>
//                         </div>
//                     </div>

//                     {/* Description */}
//                     <div className="mb-8">
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             Course Description *
//                         </label>
//                         <textarea
//                             name="course_description"
//                             value={data.course_description}
//                             onChange={handleInputChange}
//                             required
//                             rows="4"
//                             className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                             placeholder="Enter course description"
//                         />
//                     </div>

//                     {/* Form Actions */}
//                     <div className="flex gap-4">
//                         {isEdit ? <button
//                             type="submit"
//                             className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
//                         >
//                             {
//                                 loading.state && loading.name === "editcourse" ?
//                                     <BtnSpinner /> :
//                                     <>
//                                         <Save className="w-5 h-5" />
//                                         <span className='text-white'>Update Course</span>
//                                     </>
//                             }

//                         </button>
//                             :
//                             <button
//                                 type="submit"
//                                 className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
//                             >
//                                 {
//                                     loading.state && loading.name === "addcourse" ?
//                                         <BtnSpinner /> :
//                                         <>
//                                             <Save className="w-5 h-5" />
//                                             <span className='text-white'>Create Course</span>
//                                         </>
//                                 }

//                             </button>}
//                         <button
//                             type="button"
//                             onClick={() => close()}
//                             className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
//                         >
//                             <X className="w-5 h-5" />
//                             Cancel
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// }

// export default AddOrEditCourse;


import { useEffect, useState } from 'react';
import { Save, X } from 'lucide-react';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import BtnSpinner from '../../components/BtnSpinner';

function AddOrEditCourse({ close, setRefresh, course }) {

    const token = localStorage.getItem("token");

    const [data, setData] = useState({
        course_id: "",
        course_title: "",
        course_description: "",
        course_price: "",
        course_discount_percentage: "",
        course_image: "",
        course_rating: "",
        course_status: "",
        course_precedance: "",
        notes: {
            validity: "",
            currency: "",
            type: "recorded",
            classDate: "",
            classTime: "",
            zoomLink: ""
        }
    });

    const [isEdit, setIsEdit] = useState(false);
    const [previewImage, setPreviewImage] = useState("");
    const [loading, setLoading] = useState({ state: false, name: "" });

    const isLiveCourse = data?.notes?.type === "live";

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            [name]: value
        }));

        if (name === 'course_image') {
            setPreviewImage(value);
        }
    };

    const handleNotesChange = (key, value) => {
        setData(prev => ({
            ...prev,
            notes: {
                ...prev.notes,
                [key]: value
            }
        }));
    };

    const handleCourseTypeToggle = () => {
        setData(prev => ({
            ...prev,
            notes: {
                ...prev.notes,
                type: prev?.notes?.type === "live" ? "recorded" : "live"
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (course) {
            await handleEditCourse(course?.course_id)
        } else {
            await handleAddCourse();
        }
    };

    const handleAddCourse = async () => {
        setLoading({ state: true, name: "addcourse" });
        try {
            const res = await Apirequests("courses/create-course", "POST", data, {
                Authorization: `Bearer ${token}`,
            });
            if (res?.success) {
                SuccessTost(res?.message);
                close();
                setRefresh((prev) => !prev)
            } else {
                ErrorTost(res?.message)
            }
        } catch (error) {
            console.log(error, 'create course error');
            ErrorTost("Something went wrong, please try again later.")
        }
        setLoading({ state: false, name: "" })
    }

    const handleEditCourse = async (id) => {
        setLoading({ state: true, name: "editcourse" });
        try {
            const res = await Apirequests(`courses/edit-course/${id}`, 'PUT', data, {
                Authorization: `Bearer ${token}`
            });
            if (res?.success) {
                SuccessTost(res?.message);
                close();
                setRefresh((prev) => !prev)
            }
        } catch (error) {
            console.log(error, 'create course error');
            ErrorTost("Something went wrong, please try again later.")
        }
        setLoading({ state: false, name: "" })
    }

    const handleReset = () => {
        setData({
            course_id: "",
            course_title: "",
            course_description: "",
            course_price: "",
            course_discount_percentage: "",
            course_image: "",
            course_rating: "",
            course_status: "",
            course_precedance: "",
            total_lesson: "",
            total_chapters: "",
            notes: {
                validity: "",
                currency: "",
                type: "recorded",
                classDate: "",
                classTime: "",
                zoomLink: ""
            }
        });
        setPreviewImage("");
        setIsEdit(false);
    };

    useEffect(() => {
        if (course) {
            setData({
                course_id: course?.course_id || "",
                course_title: course?.course_title || "",
                course_description: course?.course_description || "",
                course_price: course?.course_price || "",
                course_discount_percentage: course?.course_discount_percentage || "",
                course_image: course?.course_image || "",
                course_rating: course?.course_rating || "",
                course_status: course?.course_status || "",
                course_precedance: course?.course_precedance || "",
                notes: {
                    validity: course?.notes?.validity || "",
                    currency: course?.notes?.currency || "",
                    type: course?.notes?.type || "recorded",
                    classDate: course?.notes?.classDate || "",
                    classTime: course?.notes?.classTime || "",
                    zoomLink: course?.notes?.zoomLink || ""
                }
            });
            setPreviewImage(course?.course_image)
            setIsEdit(true)
        }

        return () => {
            setData({
                course_id: "",
                course_title: "",
                course_description: "",
                course_price: "",
                course_discount_percentage: "",
                course_image: "",
                course_rating: "",
                course_status: "",
                course_precedance: "",
                notes: {
                    validity: "",
                    currency: "",
                    type: "recorded",
                    classDate: "",
                    classTime: "",
                    zoomLink: ""
                }
            })
            setIsEdit(false);
            setPreviewImage(null)
        }
    }, [course])

    return (
        <div className="py-2 px-2 sm:px-2 lg:px-2">
            <div>
                <div className="flex justify-between items-center mb-2">
                    <h1 className="text-3xl font-bold text-gray-900">
                        {isEdit ? 'Edit Course' : 'Add New Course'}
                    </h1>
                    <div className="flex gap-4">
                        {!isEdit && <button
                            onClick={handleReset}
                            className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-700"
                        >
                            Reset Form
                        </button>}
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="bg-white rounded-2xl">
                    <div className="mb-8">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Course Image Preview
                        </label>
                        <div className="relative h-72 w-full bg-gray-100 rounded-lg overflow-hidden">
                            {previewImage ? (
                                <img
                                    src={previewImage}
                                    alt="Course preview"
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="flex items-center justify-center h-full text-gray-400">
                                    No image preview available
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Course Title *
                            </label>
                            <input
                                type="text"
                                name="course_title"
                                value={data.course_title}
                                onChange={handleInputChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter course title"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Image URL *
                            </label>
                            <input
                                type="url"
                                name="course_image"
                                value={data.course_image}
                                onChange={handleInputChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter image URL"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Course ID
                            </label>
                            <input
                                type="text"
                                name="course_id"
                                value={data.course_id}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter course ID"
                            />
                        </div>
                    </div>

                    <div>
                        <div className='mb-4'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Course Type
                            </label>
                            <div className="flex items-center gap-3">
                                <button
                                    type="button"
                                    onClick={handleCourseTypeToggle}
                                    className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors ${
                                        isLiveCourse ? 'bg-blue-600' : 'bg-gray-300'
                                    }`}
                                >
                                    <span
                                        className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                                            isLiveCourse ? 'translate-x-6' : 'translate-x-1'
                                        }`}
                                    />
                                </button>
                                <span className="text-sm font-medium text-gray-700">
                                    {isLiveCourse ? 'Live' : 'Recorded'}
                                </span>
                            </div>
                        </div>

                        {isLiveCourse && (
                            <>
                                <div className='mb-2'>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Class Date
                                    </label>
                                    <input
                                        type="date"
                                        value={data?.notes?.classDate}
                                        onChange={(e) => handleNotesChange("classDate", e.target.value)}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    />
                                </div>

                                <div className='mb-2'>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Class Time
                                    </label>
                                    <input
                                        type="time"
                                        value={data?.notes?.classTime}
                                        onChange={(e) => handleNotesChange("classTime", e.target.value)}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    />
                                </div>

                                <div className='mb-2'>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Zoom Link
                                    </label>
                                    <input
                                        type="url"
                                        value={data?.notes?.zoomLink}
                                        onChange={(e) => handleNotesChange("zoomLink", e.target.value)}
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter zoom link"
                                    />
                                </div>
                            </>
                        )}

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Price *
                            </label>
                            <input
                                type="tel"
                                name="course_price"
                                value={data.course_price}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter price"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Currency
                            </label>
                            <select
                                value={data?.notes?.currency}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                onChange={(e) => handleNotesChange("currency", e.target.value)}
                            >
                                <option value={""}>Select Currency</option>
                                <option value={"INR"}>Indian Rupee (INR)</option>
                                <option value={"USD"}>United States Dollar (USD)</option>
                            </select>
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Discount Percentage
                            </label>
                            <input
                                type="number"
                                name="course_discount_percentage"
                                value={data?.course_discount_percentage}
                                onChange={handleInputChange}
                                min="0"
                                max="100"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter discount"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Rating
                            </label>
                            <input
                                type="tel"
                                name="course_rating"
                                value={data.course_rating}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter rating"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Validity(days) *
                            </label>
                            <input
                                type="tel"
                                name="total_lesson"
                                value={data?.notes?.validity}
                                onChange={(e) => handleNotesChange("validity", e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter course validity"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Precedence Level *
                            </label>
                            <input
                                type="tel"
                                name="course_precedance"
                                value={data.course_precedance}
                                onChange={handleInputChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Enter Priority Number"
                            />
                        </div>

                        <div className='mb-2'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Status *
                            </label>
                            <select
                                name="course_status"
                                value={data.course_status}
                                onChange={handleInputChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="Active">Active</option>
                                <option value="Disabled">Disabled</option>
                            </select>
                        </div>
                    </div>

                    <div className="mb-8">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Course Description *
                        </label>
                        <textarea
                            name="course_description"
                            value={data.course_description}
                            onChange={handleInputChange}
                            required
                            rows="4"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter course description"
                        />
                    </div>

                    <div className="flex gap-4">
                        {isEdit ? <button
                            type="submit"
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                        >
                            {
                                loading.state && loading.name === "editcourse" ?
                                    <BtnSpinner /> :
                                    <>
                                        <Save className="w-5 h-5" />
                                        <span className='text-white'>Update Course</span>
                                    </>
                            }

                        </button>
                            :
                            <button
                                type="submit"
                                className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                            >
                                {
                                    loading.state && loading.name === "addcourse" ?
                                        <BtnSpinner /> :
                                        <>
                                            <Save className="w-5 h-5" />
                                            <span className='text-white'>Create Course</span>
                                        </>
                                }

                            </button>}
                        <button
                            type="button"
                            onClick={() => close()}
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors"
                        >
                            <X className="w-5 h-5" />
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddOrEditCourse;